import {useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {generateOptions} from './profileFormOptions';
import {FormSection} from '../../../../../../components/FormMaker/types';
import {JobSearchStatus, MatchingStatus, ProfileVisibility} from '../../../../../../domain/settings';
import {ApplicantProfile} from '../../../types';

export const useSettingsSection = (profile: ApplicantProfile): FormSection[] => {
  const {t: tfs} = useTranslation('translation', {keyPrefix: 'applicantProfile.form.settings'});
  const {t: td} = useTranslation('domain');

  const settings = useMemo(
    () => ({
      profileVisibility: profile.profileVisibility,
      jobSearchStatus: profile.jobSearchStatus,
      matchingStatus: profile.matchingStatus,
    }),
    [profile]
  );

  return useMemo<FormSection[]>(
    () => [
      {
        type: 'title',
        data: {
          title: tfs('title'),
        },
      },
      {
        type: 'subtitle',
        data: {
          subtitle: tfs('findability'),
        },
      },
      {
        type: 'radio',
        data: {
          name: 'profileVisibility',
          options: generateOptions(ProfileVisibility, 'profileVisibilityEnum', td),
          initialValue: settings.profileVisibility,
        },
      },
      {
        type: 'subtitle',
        data: {
          subtitle: tfs('jobSearch'),
        },
      },
      {
        type: 'radio',
        data: {
          name: 'jobSearchStatus',
          options: generateOptions(JobSearchStatus, 'jobSearchStatusEnum', td),
          initialValue: settings.jobSearchStatus,
        },
      },
      {
        type: 'subtitle',
        data: {
          subtitle: tfs('matchingStatus'),
        },
      },
      {
        type: 'radio',
        data: {
          name: 'matchingStatus',
          options: generateOptions(MatchingStatus, 'matchingStatusEnum', td),
          initialValue: settings.matchingStatus,
        },
      },
    ],
    [settings, td, tfs]
  );
};
